import { cn } from '@ibas/ui';

export interface ProgrammeTransparencyProps {
  className?: string;
}

/**
 * ProgrammeTransparency — the accreditation-mandated "Institutional Status /
 * Program-Specific Accreditation / Ongoing Accreditation Efforts" statement that
 * MUST appear, verbatim, on every programme page (ibas-brand compliance ref).
 *
 * The copy below is reproduced word-for-word from the accreditation requirements
 * and MUST NOT be edited, reworded or "corrected" — its US English spelling
 * ("program", "recognized") is intentional and locked. Only the surrounding
 * layout may change. Placement is the page bottom.
 */
export function ProgrammeTransparency({ className }: ProgrammeTransparencyProps) {
  return (
    <section
      aria-labelledby="programme-transparency-heading"
      className={cn('bg-muted/40 px-6 py-12 lg:px-16', className)}
    >
      <div className="mx-auto w-full max-w-3xl">
        <h2
          id="programme-transparency-heading"
          className="font-label text-xs tracking-[0.22em] text-muted-foreground uppercase"
        >
          Accreditation &amp; institutional status
        </h2>

        <div className="mt-6 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <div>
            <h3 className="font-display text-base font-semibold text-foreground">
              Institutional Status
            </h3>
            <p className="mt-2">
              IBAS is a private institution and does not hold recognition under the Swiss
              Higher Education Act (HEdA). As such, it is not accredited by the Swiss federal
              government or any cantonal authority. For more information about Swiss
              accreditation standards, visit AAQ.
            </p>
          </div>

          <div>
            <h3 className="font-display text-base font-semibold text-foreground">
              Program-Specific Accreditation
            </h3>
            <p className="mt-2">
              IBAS has achieved ACBSP accreditation for its MBA and DBA programs. The
              Accreditation Council for Business Schools and Programs (ACBSP) is recognized by
              the Council for Higher Education Accreditation (CHEA) in the United States.
            </p>
          </div>

          <div>
            <h3 className="font-display text-base font-semibold text-foreground">
              Ongoing Accreditation Efforts
            </h3>
            <p className="mt-2">
              IBAS is actively pursuing Swiss University of Applied Sciences accreditation.
              However, it is important to note that current or existing programs are not
              guaranteed to be included under any future accreditation, and such a
              recognition/accreditation is not guaranteed to be obtained.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
